import { EntryPoint } from "./EntryPoint";
import { installBrowserTranslateGuard } from "./core/installBrowserTranslateGuard";
import { lazy } from "react";
import ReactDOM from "react-dom/client";

export const AppEntrypoint = lazy(() => import("./AppEntrypoint"));
export const KeycloakThemeEntrypoint = lazy(
  () => import("./core/keycloak-theme/KeycloakThemeEntrypoint"),
);

installBrowserTranslateGuard();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<EntryPoint />);
}
